export default __webpack_public_path__ + "static/media/Stonesplitter.cdbf9a54.jpg";